<template>
  <div>
    <div class="panel panel-primary">
      <div class="panel-body">
        <parcelamento-data :payment-plan="paymentPlan" :student="student" v-if="paymentPlan.id" />
      </div>
    </div>
    <div class="panel panel-primary student-view__panel-personal-data">
      <div class="panel-body">
        <ul class="nav nav-tabs">
          <li class="tabulated-list active" role="presentation">
            <a data-toggle="tab" href="#personal-data-student">
              Dados pessoais
            </a>
          </li>
          <li class="tabulated-list" role="presentation">
            <a data-toggle="tab" href="#personal-data-address">
              Endereço
            </a>
          </li>
          <li class="tabulated-list" role="presentation">
            <a data-toggle="tab" href="#personal-data-offer">
              Dados da oferta
            </a>
          </li>
          <li v-if="!isDigitalEnrollment" class="tabulated-list" role="presentation">
            <a data-toggle="tab" href="#personal-data-financial">
              Dados financeiros
            </a>
          </li>
          <li v-else class="tabulated-list" role="presentation">
            <a data-toggle="tab" href="#personal-data-ingress">
              Dados do vestibular
            </a>
          </li>
        </ul>
        <div class="tab-content">
          <section class="tab-pane fade in active" id="personal-data-student">
            <personal-data
              v-if="personalData.id"
              :personal-data="personalData"
              :student="student"
              :options="{gender: genderOptions, marital: maritalStatusOptions}"
              :tab-name="'personalData'"
              @form-update="paymentPlan.personalData={...personalData, ...$event}"
            />
          </section>
          <section class="tab-pane fade" id="personal-data-address">
            <address-data :house-data="houseData" :house-data-city="houseDataCity" :house-data-state="houseDataState" />
          </section>
          <section class="tab-pane fade" id="personal-data-financial">
            <financial-data :financial-data="financialData" />
          </section>
          <section class="tab-pane fade" id="personal-data-offer">
            <offer-data :offer="offer" />
          </section>
          <section class="tab-pane fade in active" id="personal-data-ingress">
            <ingress-data :payment-plan="paymentPlan" />
          </section>
        </div>
      </div>
    </div>
    <guarantor-data
      v-if="hasGuarantor"
      :guarantor-data="guarantorData"
      :options="{gender: genderOptions, marital: maritalStatusOptions}"
    />
    <documents
      v-if="hasDocuments"
      :payment-plan="paymentPlan"
      @documents-in-analysis="updatePaymentPlanStatus"
      @documents-approved="updatePaymentPlanStatus"
      @documents-reproved="updatePaymentPlanStatus"
      :course="course"
    />
  </div>
</template>
<script>
import FinancialData from 'pages/Parcelamento/StudentView/PaymentPlanData/FinancialData';
import ParcelamentoData from 'pages/Parcelamento/StudentView/PaymentPlanData/ParcelamentoData';
import PersonalData from 'pages/Parcelamento/StudentView/PaymentPlanData/PersonalData';
import AddressData from 'pages/Parcelamento/StudentView/PaymentPlanData/AddressData';
import GuarantorData from 'pages/Parcelamento/StudentView/PaymentPlanData/GuarantorData';
import Documents from 'pages/Parcelamento/StudentView/PaymentPlanData/Documents';
import OfferData from 'pages/Parcelamento/StudentView/PaymentPlanData/OfferData';
import IngressData from 'pages/Parcelamento/StudentView/PaymentPlanData/IngressData';

export default {
  components: {
    AddressData,
    FinancialData,
    ParcelamentoData,
    PersonalData,
    GuarantorData,
    Documents,
    OfferData,
    IngressData,
  },
  props: {
    student: {
      type: Object,
      required: true,
    },
    paymentPlan: {
      type: Object,
      required: true,
    },
    genderOptions: {
      type: Array,
      default: () => [],
    },
    maritalStatusOptions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isDigitalEnrollment() {
      if (this.paymentPlan) {
        return this.paymentPlan.planType === 'digital_enrollment';
      }
      return false;
    },
    guarantorData() {
      return this.paymentPlan.guarantorData || {};
    },
    offer() {
      return this.paymentPlan.offer || {};
    },
    course() {
      return this.offer.course || {};
    },
    personalData() {
      return this.paymentPlan.personalData || {};
    },
    houseData() {
      return this.paymentPlan.houseData || {};
    },
    financialData() {
      return this.paymentPlan.financialData || {};
    },
    hasGuarantor() {
      return this.guarantorData && this.guarantorData.id;
    },
    campus() {
      return this.course.campus || {};
    },
    houseDataCity() {
      return this.houseData.city || {};
    },
    houseDataState() {
      return this.houseData.state || {};
    },
    documents() {
      return this.paymentPlan.documents || [];
    },
    hasDocuments() {
      return this.paymentPlan.documents ? Object.keys(this.paymentPlan.documents).length : false;
    },
  },
  methods: {
    updatePaymentPlanStatus(status) {
      this.$emit('update-payment-plan-status', status);
    },
  },
};
</script>
